module.exports = __webpack_public_path__ + "static/media/LK_Unlock.7732498b.svg";